import React from 'react';

import Container from '@material-ui/core/Container'
import SignOut from './SignOut';
import { Alert, AlertTitle } from '@material-ui/lab';

const AccountErrorPage = ({ title = 'Something bad happened', message = "It's unclear what" }) => {
    return (
        <Container style={{ padding: '1rem' }}>
            
            <Alert style={{ marginBottom: '1rem' }} severity="error" variant="filled"><AlertTitle>{title}</AlertTitle>{message}</Alert>
            <SignOut color="default" buttonText='Click to continue' />
            
        </Container>
    );
};

export default AccountErrorPage;